import React from 'react'

function Notfound() {
  return (
    <div>

        <div className="container-fluid pt-5 bg-primary hero-header">
          <div className="container pt-5">
            <div className="row g-5 pt-5">
              <div className="col-lg-12 align-self-center text-center ">
                <h1 className="display-4 text-white mb-4 animated slideInRight">404 Error</h1><br/><br/>
              </div>
              
            </div>
          </div>
        </div>
   
    
    </div>


  )
}

export default Notfound